import { State, Profil } from "./state";
import { updateProfil } from "src/api/user";

export const SET_USER = "SET_USER";
export const SET_PROFIL = "SET_PROFIL";
export function setUser(user: State) {
  return { type: SET_USER as typeof SET_USER, user };
}
export function setProfil(profil: Profil) {
  return { type: SET_PROFIL as typeof SET_PROFIL, profil };
}

export function updateUserProfil(profil: Profil) {
  return async dispatch => {
    const userProfil = await updateProfil(profil);

    dispatch(setProfil(userProfil));
  };
}
export type Actions = ReturnType<typeof setUser> | ReturnType<typeof setProfil>;



// WEBPACK FOOTER //
// ./src/redux/user/actions.ts